import MarineUnitHtml from './templates/unit.marine.html';

export function MarineUnits () {
  return {
    //controller: 'VehicleInvoicesCtrl',
    restrict: 'E',
    templateUrl: MarineUnitHtml
  }
}